import { Directive, ElementRef, HostListener, Input, Renderer2, ViewContainerRef, ComponentRef, createComponent, EnvironmentInjector } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
  selector: 'img[fallbackIcon]',
  standalone: true
})
export class ImageFallbackDirective {
  @Input() fallbackIcon = 'image';
  @Input() fontSize = '24px';
  private iconCreated = false;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private injector: EnvironmentInjector
  ) {}

  @HostListener('error')
  onError() {
    if (this.iconCreated) return; // Prevent multiple executions
    
    // console.log('Image load error, applying fallback icon.');
    this.iconCreated = true;
    
    const img = this.el.nativeElement;
    const parent = this.renderer.parentNode(img);
    
    // Hide the broken image
    this.renderer.setStyle(img, 'display', 'none');
    
    // Create MatIcon component dynamically
    const iconComponentRef: ComponentRef<MatIcon> = createComponent(MatIcon, {
      environmentInjector: this.injector,
      elementInjector: this.viewContainerRef.injector
    });
    
    // Set the icon name
    iconComponentRef.instance.fontIcon = this.fallbackIcon;
    
    // Apply font size
    const iconElement = iconComponentRef.location.nativeElement;
    this.renderer.setStyle(iconElement, 'font-size', this.fontSize);
    this.renderer.setStyle(iconElement, 'height', this.fontSize);
    this.renderer.setStyle(iconElement, 'width', this.fontSize);
    this.renderer.setStyle(iconElement, 'opacity', '30%');
    
    // Insert the icon after the image
    this.renderer.insertBefore(parent, iconElement, img.nextSibling);
    
    // Attach to change detection
    iconComponentRef.changeDetectorRef.detectChanges();
  }
}